import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Lock } from 'lucide-react';
export const OfferSection = () => {
  return <Section variant="navy" id="offer" className="relative overflow-hidden" data-id="element-98">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-99"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-100">
        <FadeIn data-id="element-101">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-102">
            Recupera tu paz <span className="text-gold" data-id="element-103">hoy mismo.</span>
          </h2>
          <p className="text-xl text-cream-muted mb-12" data-id="element-104">
            No esperes a que el próximo ataque de pánico te tome desprevenido.
            Adquiere el sistema completo Biblia Anti-Ansiedad por un pago único
            de lanzamiento.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} className="bg-navy-light/80 backdrop-blur-sm p-8 md:p-12 rounded-3xl border border-gold/30 shadow-2xl" data-id="element-105">
          <div className="mb-8" data-id="element-106">
            <p className="text-cream-muted uppercase tracking-wider text-sm font-semibold mb-2" data-id="element-107">
              Precio especial
            </p>
            <div className="flex justify-center items-baseline gap-2" data-id="element-108">
              <span className="text-5xl md:text-7xl font-bold text-gold" data-id="element-109">
                $17
              </span>
              <span className="text-xl text-gold/80 font-medium" data-id="element-110">USD</span>
            </div>
          </div>

          <Button onClick={() => window.open('https://equilibriazone.com/cart/52111492383003:1', '_blank')} className="w-full md:w-auto md:px-12 py-5 text-xl mb-6" data-id="element-111">
            Descargar Ahora
          </Button>

          <div className="flex items-center justify-center gap-2 text-sm text-cream-muted/80" data-id="element-112">
            <Lock className="w-4 h-4" data-id="element-113" />
            <span data-id="element-114">
              Acceso inmediato y privado. Tu paz comienza con un clic.
            </span>
          </div>
        </FadeIn>
      </div>
    </Section>;
};